console.log("Custom Product JS file");
document.addEventListener('DOMContentLoaded', function () {
    const view_more_btn = document.querySelector('#view_more_btn');
    const all_offers_container = document.querySelector('#all_offers_container');
    const all_offers_containerCloseWrap = document.querySelector('#all_offers_containerCloseContainer');
    if(view_more_btn){
        view_more_btn.addEventListener('click', function(){
            console.log("show offers");
            all_offers_container.style.display = "block";
            all_offers_containerCloseWrap.style.display = "block";
            all_offers_container.classList.add('show-block')
        })
    }
    const offers_close_btn = document.querySelector("#offers_close_btn");
    if(offers_close_btn){
      offers_close_btn.addEventListener('click', function(){
          console.log('close offers');
          all_offers_container.style.display = "none";
          all_offers_containerCloseWrap.style.display = "none";
          all_offers_container.classList.remove('show-block')
      })
    }
    document.querySelectorAll('.copy_btn').forEach(function (button) {
        button.addEventListener('click', function () {

        const offerBox = this.closest('.offer_wrapper');
        const couponText = offerBox.querySelector('.coupon_txt_new').innerText.trim();
        const copiedTXT = offerBox.querySelector('.cpy');

        navigator.clipboard.writeText(couponText)
            .then(() => {
            console.log('Copied');

            // Show "Copied"
            copiedTXT.classList.remove('hide');

            // Hide again after 1.5s
            setTimeout(() => {
                copiedTXT.classList.add('hide');
            }, 1500);
            })
            .catch(() => {
            alert('Copy failed');
            });
        });
    });

    // GIFT CARD TOGGLE CODE
    const giftCardCheckbox = document.getElementById('gift_card_checkbox');
    const productFormSticky = document.querySelectorAll('.product-single__form.custom-sticky');
    // const productFormMainPDP = document.querySelectorAll('.product-single__form.custom_main_pdp');
     const giftUpsellSection = document.querySelector('[data-gift-upsell]');

    function syncAddonState(isChecked) {

     // keep your existing logic
      productFormSticky.forEach(form => {
      form.dataset.addAddon = isChecked ? 'true' : 'false';
     });

     // 🔥 THIS IS THE IMPORTANT PART
     if (giftUpsellSection) {
       if (isChecked) {
         giftUpsellSection.removeAttribute('hidden');
         giftUpsellSection.style.display = '';
        } else {
         giftUpsellSection.setAttribute('hidden', 'hidden');
         giftUpsellSection.style.display = 'none';
      } 
     }

      console.log('Gift checked:', isChecked);
    }

    // Initial state on load
    // if(giftCardCheckbox){
    //   syncAddonState(giftCardCheckbox.checked);

    //   // Toggle on change
    //   giftCardCheckbox.addEventListener('change', function () {
    //       syncAddonState(this.checked);
    //       console.log('Addon enabled:', this.checked);
    //   });
    // }
    

    document.querySelectorAll('[data-gift-root]').forEach(function (root) {
        var checkbox = root.querySelector('[data-gift-toggle]');
        var details = root.querySelector('[data-gift-details]');
        var price = root.querySelector('[data-gift-price]');
        var giftVariantId = root.dataset.giftId;
        var mainProductHandle = root.dataset.mainProductHandle;
        var mainProductName = root.dataset.mainProductName;

        //gift card elements
        const gift_card_ele = details.querySelector('[data-gift-field="gift_card"]');
        const gift_to_ele = details.querySelector('[data-gift-field="gift_to"]');
        const gift_from_ele = details.querySelector('[data-gift-field="gift_from"]');
        const gift_message_ele = details.querySelector('[data-gift-field="gift_message"]');

        // var varID = root.querySelector('[data-gift-id]');

        root.getGiftData = function () {
        if (!checkbox.checked) return null;
        let gift_card = gift_card_ele ? gift_card_ele.value : '';
        let gift_to = gift_to_ele ? gift_to_ele.value : '';
        let gift_message = gift_message_ele ? gift_message_ele.value : '';
        let gift_from = gift_from_ele ? gift_from_ele.value : '';
        
            return {
              gift_card: gift_card,

              gift_to: gift_to,

              gift_from: gift_from,

              gift_message: gift_message
            };
        };


        function sync() {
            if (checkbox.checked) {
            root.classList.add('is-gift-active');
            details.removeAttribute('hidden');
            if (price) price.style.display = 'inline-flex';
            // const giftData = getGiftData();
            // console.log('Gift enabled:', giftData);
            } else {
            root.classList.remove('is-gift-active');
            details.setAttribute('hidden', 'hidden');
            if (price) price.style.display = 'none';

            console.log('Gift disabled');
            }
        }
        checkbox.addEventListener('change', sync);
        sync();
    });

    // share button code for PDP
    const shareButtons = document.querySelectorAll('button.share_btn');

    if(shareButtons.length){
      shareButtons.forEach((shareButton)=>{
        if (!shareButton) return;

        shareButton.addEventListener('click', function () {
          const shareData = {
            title: document.title,
            text: document.title,
            url: window.location.href
          };

          // 1️⃣ Native Share (mobile)
          if (navigator.share) {
            navigator.share(shareData).catch(() => {});
            return;
          }

          // 2️⃣ Clipboard API (modern browsers)
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(window.location.href)
              .then(() => {
                alert('Link copied to clipboard');
              })
              .catch(() => {
                fallbackCopy();
              });
          } else {
            fallbackCopy();
          }
        });
      })
    }

    function fallbackCopy() {
      const tempInput = document.createElement('textarea');
      tempInput.value = window.location.href;
      tempInput.setAttribute('readonly', '');
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';

      document.body.appendChild(tempInput);
      tempInput.select();
      tempInput.setSelectionRange(0, tempInput.value.length);

      try {
        const success = document.execCommand('copy');
        alert(success ? 'Link copied to clipboard' : 'Unable to copy link');
      } catch (err) {
        alert('Copy not supported on this browser');
      }

      document.body.removeChild(tempInput);
    }

    document.addEventListener('click', async (event) => {
      const copyButton = event.target.closest('.deal-badge[data-coupon-code]');

      if (!copyButton) return;

      const couponCode = copyButton.dataset.couponCode;
      const successMessage = copyButton.querySelector('.copy-success');

      try {
        await navigator.clipboard.writeText(couponCode);

        successMessage.style.display = 'inline';

        setTimeout(() => {
          successMessage.style.display = 'none';
        }, 1500);

      } catch (error) {
        console.error('Failed to copy coupon code:', error);
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
const dealsWrapper = document.querySelector('.deals-wrapper');
  if (
    dealsWrapper &&
    typeof Flickity !== 'undefined' &&
    window.matchMedia('(min-width: 750px)').matches
  ) {
    new Flickity(dealsWrapper, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      groupCells: false
    });
  }
});